import React from 'react'

const CoreLayout = ({children}) => (
  <div className="quote-engine-layout container">
    {children}
  </div>
)

export default CoreLayout